import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotificationState } from './notification.reducer';

export const selectFeatureNotification = createFeatureSelector<NotificationState>('notification');

export const selectNotification = createSelector(selectFeatureNotification, (s) => s);
